import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

const Breadcrumb = (props) => {
  const { activeTab, obsDatasetSummary } = props;

  if (!obsDatasetSummary) {
    return null;
  }

  const links = [
    {
      label: 'Observing Platforms',
      path: '/data-console#my-platforms',
    },
    {
      label: obsDatasetSummary?.platform_name,
      path: `/data-console/manage/${obsDatasetSummary?.obs_dataset_id}`,
    },
  ];

  if (activeTab && activeTab !== 'dashboard') {
    links.push({
      label: activeTab.charAt(0).toUpperCase() + activeTab.slice(1),
      path: `/data-console/manage/${obsDatasetSummary?.obs_dataset_id}/${activeTab}`,
    });
  }

  return (
    <div
      style={{
        marginBottom: 5,
      }}
    >
      {links.map((link, index) => (
        <>
          <Link
            key={index}
            to={link.path}
            style={{
              color: index === links.length - 1 ? '#DAE4EA' : '#769BB3',
            }}
          >
            {link.label}
          </Link>
          {index < links.length - 1 && (
            <span
              style={{
                color: '#769BB3',
                margin: '0 5px',
              }}
            >
              /
            </span>
          )}
        </>
      ))}
    </div>
  );
};

Breadcrumb.propTypes = {
  activeTab: PropTypes.string,
  obsDatasetSummary: PropTypes.object,
};

Breadcrumb.defaultProps = {
  activeTab: '',
  obsDatasetSummary: {},
};

export default Breadcrumb;
